import React from 'react';
import styled from "styled-components";
import { 
    StyledLink
 } from "./index";

 const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`

const Button = styled.button`
    min-height: 70px;
    line-height: 1;
    font-weight: 700;
    font-size: 16px;
    text-decoration: none;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background-color: ${props => props.theme.codanColors.codanBlue};
    padding: 0px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all ease-in .15s;
    border: 0;
    width: 100%;
    margin: 5px 0;

    &:hover {
        opacity: 0.7;
        background-color: ${props => props.theme.codanColors.codanBlue};
    }

    ${props => props.theme.mediaQueries.medium}{
        width: 49.50%;
    }
`

const ButtonWrapper = ({
    buttons,
    links
}) => {
    const renderButtons = (buttons) => {
        return buttons.map((button, i) => {
            return (
                <Button 
                    key={i}
                    type='button'
                    name={button.name}
                    onClick={button.onClick}
                >
                    {button.text}
                </Button>
            )
        })
    }

    const renderLinks = (links) => {
        return links.map((link, i) => {
            return (
                <StyledLink
                    key={i}
                    to={link.to}
                >
                    {link.text}
                </StyledLink>
            )
        })
    }

    return (
        <Wrapper>
            {renderButtons(buttons)}
        </Wrapper>

    )
}

export default ButtonWrapper;